import { render, staticRenderFns } from "./InspectionRecordList.vue?vue&type=template&id=21a83132&scoped=true&"
import script from "./InspectionRecordList.vue?vue&type=script&lang=js&"
export * from "./InspectionRecordList.vue?vue&type=script&lang=js&"
import style0 from "./InspectionRecordList.vue?vue&type=style&index=0&id=21a83132&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a83132",
  null
  
)

export default component.exports